"use strict";

var config = require("config");

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").service("timeService", timeService);

  timeService.$inject = ["moment"];

  function timeService(moment) {

    var formatStr = "M/D/YYYY h:mm a ZZ";

    var service = {
      getFormattedTime: getFormattedTime,
      getFormattedTime2: getFormattedTime2,
      getEpochFormattedTime: getEpochFormattedTime
    };

    return service;

    /**
     * Get formatted time given parameters in the format below:
     * @param {string} webSvcReturnTime - The web service time string returned by the web service. Format is "2021-01-22T21:22:46".
     * @param {string} webSvcReturnOffset - The web service UTC time offset string. Format is "+0400".
     */
    function getFormattedTime(webSvcReturnTime, webSvcReturnOffset) {
      if (!webSvcReturnTime || !webSvcReturnOffset) {
        return "--";
      }

      // parse the time (format: 2021-01-22T21:22:46)
      var timeParts = webSvcReturnTime.split(/[T:\-]+/);
      var year = timeParts[0];
      var month = timeParts[1];
      var date = timeParts[2];
      var hours = timeParts[3];
      var mins = timeParts[4];

      // + or -
      var sign = webSvcReturnOffset.charAt(0);
      var offset = parseInt(webSvcReturnOffset.charAt(1) + webSvcReturnOffset.charAt(2));

      if (sign === "-") {
        hours -= offset;
      } else {
        hours += offset;
      }

      var suffix = hours >= 12 ? 'pm' : 'am';

      // only -12 from hours if it is greater than 12 (if not back at mid night)
      hours = hours > 12 ? hours - 12 : hours;

      // if 00 then it is 12 am
      hours = hours == '00' ? 12 : hours;

      // want: m/d/yyyy h:mm a offset
      var finalTime = month + "/" + date + "/" + year + " " + hours + ":" + mins + " " + suffix + " " + webSvcReturnOffset;
      return finalTime;
    }

    /**
     * Get formatted time given parameters in the format below:
     * @param {string} webSvcReturnTime - The web service time string returned by the web service. Format is "3/14/2017 3:12:15 PM".
     * @param {string} webSvcReturnOffset - The web service UTC time offset string. Format is "+0400".
     */
    function getFormattedTime2(webSvcReturnTime, webSvcReturnOffset) {
      if (!webSvcReturnTime || !webSvcReturnOffset) {
        return "--";
      }
      return moment.utc(webSvcReturnTime).utcOffset(webSvcReturnOffset).format(formatStr);
    }

    function getEpochFormattedTime(webSvcReturnTime, webSvcReturnOffset) {
      if (!webSvcReturnTime || !webSvcReturnOffset) {
        return "--";
      }
      return moment.unix(webSvcReturnTime).utcOffset(webSvcReturnOffset).format(formatStr);
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/components/time.service.js